import { render } from "./FolderModal.vue?vue&type=template&id=10ac9db4"
import script from "./FolderModal.vue?vue&type=script&lang=js"
export * from "./FolderModal.vue?vue&type=script&lang=js"

import "./FolderModal.vue?vue&type=style&index=0&id=10ac9db4&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__